import { banco } from '../db/banco'
import type { Meta } from '../db/tipos'
import { mesDe } from './destrave'

// Volta ate o mes mais recente que TEM metas -- nunca da em nada. Quem chama
// mostra na tela de qual mes veio, para ela nao ser pega de surpresa por
// numeros de dois meses atras.
export async function mesDeOndeRepetir(mesAlvo: string): Promise<string | null> {
  const metas = await banco.metas.filter((m) => m.apagado_em === null).toArray()
  const meses = metas
    .map((m) => mesDe(m.periodo_inicio))
    .filter((mes) => mes < mesAlvo)
    .sort()
  return meses.length > 0 ? meses[meses.length - 1] : null
}

export async function metasParaRepetir(mesOrigem: string): Promise<Meta[]> {
  const metas = await banco.metas.filter((m) => m.apagado_em === null).toArray()
  return metas.filter((m) => mesDe(m.periodo_inicio) === mesOrigem)
}
